import styled from "styled-components";

export const Template = styled("div")`
  width: 1500px;
  height: 835px;
  background-color: white;
  display: grid;
  grid-template-rows: 90px 645px 100px;
  margin: 0;
`;

export const Header = styled("div")`
  background-color: #1ce180;
  color: white;
  font-size: 40px;
  font-family: Manrope-Bold;
  line-height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 171px 0px 153px;
`;
export const BuxtonLogoWrapper = styled("div")`
  display: flex;
  align-items: center;
`;
export const BuxtonLogo = styled("div")`
  color: #2d3b49;
  padding-right: 20px;
`;
export const BuxtonLogoAppName = styled("div")`
  padding-left: 20px;
  font-size: 36px;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
`;

export const SectionTitleCaption = styled("div")`
  font-size: 18px;
`;

export const Content = styled.div`
  padding: 21px 171px 23px 153px;
`;

export const ContentChildren = styled("div")``;

export const ContentLeft = styled("div")``;

export const SectionTitleWrapper = styled("div")``;
export const SectionTitle = styled("div")``;

export const Footer = styled("div")`
  background-color: #f7f9fb;
  align-items: center;
  margin-top: 32px;
  height: 69px;
  padding-left: 171px;
  padding-right: 171px;
`;

export const FooterFlexContent = styled("div")`
  display: flex;
`;

export const BrandLogo = styled("div")`
  flex-grow: 0;
  flex-shrink: 0;
  text-align: center;
  width: 270px;
  height: 69px;
  margin-right: 15px;
  margin-left: 4px;

  & img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
  }
`;

export const Disclaimer = styled("div")`
  height: 62px;
  flex-basis: 530px;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 610px;
  margin: 1px 0 1px 2px;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

export const ContactWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 195px 0 0;
  width: 338px;
  justify-content: flex-end;
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  height: 50px;
  justify-content: space-evenly;
  align-items: flex-end;

  & .contact-info-name {
    font-weight: 900;
    white-space: nowrap;
  }

  & .contact-info-phone {
    font-size: 12px;
    white-space: nowrap;
  }

  & .contact-info-email {
    font-size: 12px;
    white-space: nowrap;
  }
`;

export const ContactImage = styled.div`
  width: 55px;
  height: 55px;
  margin: 0 0 0 6px;
  border: 1px solid black;
  flex-grow: 0;
  flex-shrink: 0;

  & img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const Wrapper = styled("div")`
  display: flex;
  height: 100%;
`;

export const MainContent = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 43px;
`;

export const MainContentTitle = styled("div")`
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 5px;
`;

export const MainContentText = styled("div")`
  font-size: 15px;
  color: #000000;
  margin-bottom: 10px;
`;

export const MainContentChild = styled("div")`
  flex: 1;
`;
